import { Button, ButtonGroup } from "@shopify/polaris";
import { t } from "i18next";
import Modal from "../Modal";
import React from "react";
import { useSelector } from "react-redux";
import { logout } from "../../redux/features/auth/authSlice";
import useAppDispatch from "hooks/useAppDispatch";
import { useNavigate } from "react-router";
import { getLoginUrl } from "utils/environment";

const LogoutModal = ({ visible, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { loggingOut } = useSelector((state) => state.auth);

  const onLogout = () => {
    dispatch(logout())
      .then(() => {
        // Clear only authentication-related data
        localStorage.removeItem("api_key");
        localStorage.removeItem("API-KEY");
        localStorage.removeItem("is_manager");
        
        // Clear only auth-related cookies
        const authCookies = ["api_key", "API-KEY", "is_manager"];
        authCookies.forEach(cookieName => {
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname};`;
        });
        
        const isLocalhost =
            window.location.hostname === "localhost" ||
            window.location.hostname === "127.0.0.1" ||
            window.location.hostname === "[::1]" ||
            /\.local$/.test(window.location.hostname);

        if (isLocalhost) {
          navigate("/login")
          // Force redirect to ensure we leave the current page
          setTimeout(() => {
            window.location.href = "/login";
          }, 100);
        } else {
          // Redirect to login page on dev/prod
          window.location.href = getLoginUrl();
        }
      })
      .catch(() => {
        // Even if logout fails, clear auth tokens and redirect
        localStorage.removeItem("api_key");
        localStorage.removeItem("API-KEY");
        localStorage.removeItem("is_manager");
        
        const authCookies = ["api_key", "API-KEY", "is_manager"];
        authCookies.forEach(cookieName => {
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname};`;
        });
        
        navigate("/login");
        // Force redirect to ensure we leave the current page
        setTimeout(() => {
          window.location.href = "/login";
        }, 100);
      })
  };

  return (
    <Modal
      title={t("profile.logOut")}
      visible={visible}
      contentOnCenter
      onClose={onClose}
      iconType={"warning"}
      description={t("profile.sureLogout")}
      footer={
        <ButtonGroup fullWidth>
          <Button size='large' onClick={onClose}>
            {t("profile.no")}
          </Button>
          <Button variant="primary" tone="critical" size="large" onClick={onLogout} loading={loggingOut}>
            {t("profile.yes")}
          </Button>
        </ButtonGroup>
      }
    />
  );
};

export default LogoutModal;
